export class Registration {
  csUser: string;
  csUserId:number;
  csPassword: string;
  Server: string;
  port:number;
  Api: string;
  sUser: string;
  sPassword: string;
  schemaName:string;
}
//login return 1 ->success
